"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _popupConfig = require("@/api/popup/popupConfig.js");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 导入API函数
var _default = exports.default = {
  name: 'contentsstyle',
  props: {
    datas: Object,
    title: String
  },
  data: function data() {
    var checkAge = function checkAge(rule, value, callback) {
      if (value === undefined || value === null || value === '') {
        callback(new Error('请输入有效数字'));
        return;
      }
      if (value > 99) {
        callback(new Error('数字最大为99'));
        return;
      }
      callback();
    };
    var kon = function kon(rule, value, callback) {
      if (value === undefined || value === null || value === '') {
        callback(new Error('请输入有效数字'));
        return;
      }
      callback();
    };
    return {
      options: [],
      rules: {
        titleSize: [{
          required: true,
          validator: checkAge,
          trigger: 'blur'
        }],
        descriptionSize: [{
          required: true,
          validator: checkAge,
          trigger: 'blur'
        }],
        titleWeight: [{
          required: true,
          validator: kon,
          trigger: 'blur'
        }],
        descriptionWeight: [{
          required: true,
          validator: kon,
          trigger: 'blur'
        }]
      },
      predefineColors: [
      // 颜色选择器预设
      '#ff4500', '#ff8c00', '#ffd700', '#90ee90', '#00ced1', '#1e90ff', '#c71585', '#409EFF', '#909399', '#C0C4CC', 'rgba(255, 69, 0, 0.68)', 'rgb(255, 120, 0)', 'hsv(51, 100, 98)', 'hsva(120, 40, 94, 0.5)', 'hsl(181, 100%, 37%)', 'hsla(209, 100%, 56%, 0.73)', '#c7158577'],
      pageList: [],
      // 页面列表数据
      loadingPageList: false // 加载页面列表状态
    };
  },
  watch: {
    // 监听httpType变化，当选择内部链接时获取页面列表
    'datas.more.httpType': function datasMoreHttpType(newVal) {
      if (newVal === 10) {
        // 10代表内部链接
        this.getPageList();
      }
    }
  },
  created: function created() {
    // 如果初始就是内部链接，获取页面列表
    if (this.datas.more && this.datas.more.httpType === 10) {
      this.getPageList();
    }
  },
  methods: {
    handleHttpTypeChange: function handleHttpTypeChange() {
      this.datas.more.http = '';
    },
    // 获取页面列表
    getPageList: function () {
      var _getPageList = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(this.pageList.length > 0)) {
                _context.next = 1;
                break;
              }
              return _context.abrupt("return");
            case 1:
              _context.prev = 1;
              this.loadingPageList = true;
              _context.next = 2;
              return (0, _popupConfig.queryPageList)();
            case 2:
              response = _context.sent;
              if (response.code === 200 && response.data) {
                // 将返回的页面数据转换为下拉选项格式
                this.pageList = response.data.map(function (item) {
                  return {
                    value: item.pageUrl,
                    label: item.pageName
                  };
                });
              } else {
                console.error('获取页面列表失败:', response);
                this.$message.error('获取页面列表失败');
              }
              _context.next = 4;
              break;
            case 3:
              _context.prev = 3;
              _t = _context["catch"](1);
              console.error('获取页面列表错误:', _t);
              this.$message.error('获取页面列表失败');
            case 4:
              _context.prev = 4;
              this.loadingPageList = false;
              return _context.finish(4);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[1, 3, 4, 5]]);
      }));
      function getPageList() {
        return _getPageList.apply(this, arguments);
      }
      return getPageList;
    }(),
    // 处理页面选择变化
    handlePageChange: function handlePageChange(val) {
      // 当选择页面时，自动填充到http字段
      if (val) {
        this.datas.more.http = val;
      }
    }
  }
};